import { render } from "./TextShow.vue?vue&type=template&id=e9929a4a"
import script from "./TextShow.vue?vue&type=script&lang=js"
export * from "./TextShow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__